import { ALERT_CONFIG } from "../constants";
import Swal from "sweetalert2";

Swal.mixin({
  // Set default options for SweetAlert
  confirmButtonColor: "#3B7D36",
  cancelButtonColor : "#d33",
  reverseButtons    : true
});

export const toastify = ({ title, type = "success" }) => {
  return Swal.fire({
    toast            : true,
    position         : "top-end",
    showConfirmButton: false,
    timer            : 3000,
    timerProgressBar : true,
    showCloseButton  : true,
    didOpen          : (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
    icon: type,
    title
  });
};

export const confirmAlert = (options) => {
  const showCancelButton = options.showCancelButton === undefined;
  const customOptions = !options.action
    ? (options = {
        ...options,
        text               : options.text || "Do you really want to proceed?",
        confirmButtonText  : options.confirmButtonText || "Confirm",
        cancelButtonText   : options.cancelButtonText || "Cancel",
        showCancelButton,
        allowOutsideClick  : options.allowOutsideClick || false,
        showLoaderOnConfirm: true,
        preConfirm         : options.preConfirm,
        title              : options.title
      })
    : {
        ...ALERT_CONFIG[options.action],
        title: options.title || ALERT_CONFIG[options.action].title,
        text:
          options.text ||
          ALERT_CONFIG[options.action].text ||
          "Do you really want to proceed?",
        confirmButtonText:
          ALERT_CONFIG[options.action].confirmButtonText || "Confirm",
        cancelButtonText:
          ALERT_CONFIG[options.action].cancelButtonText || "Cancel",
        allowOutsideClick  : options.allowOutsideClick || false,
        showLoaderOnConfirm: true,
        preConfirm         : options.preConfirm
      };
  return Swal.fire(customOptions);
};
